import React from 'react'
import styles from '../../../styles/components/RegistrationsStatusMsg.module.scss'

interface RegistrationStatusProps {
  isNewAccount: boolean
}

const RegistrationStatusMsg: React.FC<RegistrationStatusProps> = ({ isNewAccount }) => {
  if (isNewAccount) {
    return (
      <div className={styles.successMessageContainer}>
        <h1 className={styles.title}>Ihre Registrierung war erfolgreich!</h1>
        <p className={styles.description}>Vielen Dank für Ihre Registrierung für unser Dozenten - Portal. Ihr Konto wurde erfolgreich erstellt. Um Ihre Aufnahme als Dozent abzuschließen, benötigen wir noch einige zusätzliche Informationen zu Ihrem Profil.</p>
        <br></br>
        <p className={styles.description}>Hinweis:</p>
        <ul className={styles.ulList}>
          <li>Nur die mit einem Sternchen (*) gekennzeichneten Felder müssen ausgefüllt werden, die anderen sind optional.</li>
          <li>Alle Felder, die mit einer Checkbox "public" gekennzeichnet sind, werden öffentlich auf Webseiten oder ähnlich verwendet.</li>
        </ul>
        <p className={styles.instructionsTitle}>Bitte füllen Sie die folgenden Felder aus:</p>
      </div>
    )
  } else {
    return (
      <div className={styles.successMessageContainer}>
        <h1 className={styles.title}>Ihre Profildaten</h1>
        <p className={styles.instructionsTitle}>
          Hier können Sie Ihre Profildaten ändern. Nach Prüfung durch unsere Mitarbeiter werden die Änderungen übernommen und auf der Webseite verwendet.
          <br></br>
          Bitte haben Sie etwas Geduld während des Prozesses
        </p>
      </div>
    )
  }
}

export default RegistrationStatusMsg
